// src/services/api.js
// Utilitário central - todas as chamadas de API passam por aqui
// Inclui automaticamente o token JWT e trata 401 com refresh
import { getApiBaseUrl } from "./apiBase";

// URL resolvida em apiBase.js: config.js → REACT_APP_API_URL → auto-detect
function apiUrl() {
  return getApiBaseUrl();
}


async function request(method, path, body=null) {
  const token = localStorage.getItem("accessToken");
  // Detect if using ngrok tunnel and add required header
  const BASE = apiUrl();
  const isNgrok = BASE.includes("ngrok");
  const opts  = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "Authorization": `Bearer ${token}` } : {}),
      ...(isNgrok ? { "ngrok-skip-browser-warning": "true" } : {}),
    },
  };
  if (body) opts.body = JSON.stringify(body);

  if (!BASE) {
    throw new Error("URL da API não configurada. Defina REACT_APP_API_URL no build ou API_URL em public/config.js.");
  }

  let res = await fetch(`${BASE}${path}`, opts);

  // Token expirado → tenta refresh automático
  if (res.status === 401) {
    const json = await res.json().catch(() => ({}));
    if (json.expired) {
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          const rRes = await fetch(`${BASE}/auth/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refreshToken }),
          });
          if (rRes.ok) {
            const rData = await rRes.json();
            localStorage.setItem("accessToken",  rData.accessToken);
            localStorage.setItem("refreshToken", rData.refreshToken);
            // Retry com novo token
            opts.headers["Authorization"] = `Bearer ${rData.accessToken}`;
            res = await fetch(`${BASE}${path}`, opts);
          } else {
            // Refresh falhou → logout
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            window.location.href = "/";
            return;
          }
        } catch {
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/";
          return;
        }
      }
    }
    if (res.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      window.location.href = "/";
      return;
    }
  }

  const data = await res.json();
  if (!res.ok) {
    const e = new Error(data.message || "Erro na requisição");
    e.status = res.status;
    throw e;
  }
  return data;
}

export const get    = (path)        => request("GET",    path);
export const post   = (path, body)  => request("POST",   path, body);
export const put    = (path, body)  => request("PUT",    path, body);
export const patch  = (path, body)  => request("PATCH",  path, body);
export const del    = (path)        => request("DELETE",  path);
export default request;
